import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { companyInfo, services } from '../mockData';

const offices = [
  {
    city: 'Dubai, UAE',
    company: 'HLA Technical Services',
    phone: companyInfo.phone.uae,
    address: ['411/46, Pinnacle Building,', 'Al Barsha First, Dubai, UAE'],
  },
  {
    city: 'Ajman, UAE',
    company: 'Hexalogix Automation Power Control Switchgears Manufacturing LLC',
    phone: companyInfo.phone.ajman,
    address: ['Shed No: 1, Al Bahia,', 'Ajman, UAE'],
  },
  {
    city: 'Kochi, India',
    company: 'Hexalogix Automation',
    phone: companyInfo.phone.india,
    address: ['Grande Tower, NH By-pass,', 'Aluva, Kerala, India'],
  },
];

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <footer className="bg-[#050C1A] text-gray-400">
      <div className="h-[3px] bg-[#0057B8]" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 pb-8">
        <div className="grid grid-cols-1 lg:grid-cols-[180px_minmax(0,360px)_300px] gap-10 pb-10 border-b border-white/5 items-start">
          <div>
            <h3 className="text-white text-sm font-bold tracking-[0.18em] uppercase mb-5">Company</h3>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-[17px] text-gray-500 hover:text-white transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="min-w-0">
            <h3 className="text-white text-sm font-bold tracking-[0.18em] uppercase mb-5">Services</h3>
            <div className="space-y-3 min-w-0">
              {services.map((service) => (
                <Link
                  key={service.slug}
                  to={`/services/${service.slug}`}
                  className="block text-[16px] text-gray-500 hover:text-white transition-colors whitespace-normal xl:whitespace-nowrap break-words leading-relaxed"
                >
                  {service.title}
                </Link>
              ))}
            </div>
          </div>

          <div className="min-w-0">
            <h3 className="text-white text-sm font-bold tracking-[0.18em] uppercase mb-5">Email</h3>
            <a
              href={`mailto:${companyInfo.email}`}
              className="flex items-start gap-2 text-base text-gray-400 hover:text-white transition-colors"
            >
              <Mail className="w-4 h-4 text-[#0057B8] flex-shrink-0 mt-1" />
              <span className="break-all sm:break-normal sm:whitespace-nowrap leading-relaxed">{companyInfo.email}</span>
            </a>
          </div>
        </div>

        <div className="pt-10">
          <div className="flex items-center gap-3 mb-7">
            <span className="w-10 h-[2px] bg-[#0057B8]" />
            <h3 className="text-white text-sm font-bold tracking-[0.18em] uppercase">Global Offices</h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
            {offices.map((office) => (
              <div
                key={office.city}
                className="min-w-0"
              >
                <p className="text-[#0057B8] text-sm font-bold tracking-[0.14em] uppercase mb-3">{office.city}</p>
                <p className="text-white text-[17px] font-medium leading-snug mb-4 break-words">{office.company}</p>
                <div className="space-y-3">
                  <a
                    href={`tel:${office.phone}`}
                    className="flex items-center gap-2 text-base text-gray-400 hover:text-white transition-colors"
                  >
                    <Phone className="w-4 h-4 text-[#0057B8] flex-shrink-0" />
                    {office.phone}
                  </a>
                  <div className="flex items-start gap-2 text-base text-gray-400">
                    <MapPin className="w-4 h-4 text-[#0057B8] flex-shrink-0 mt-1" />
                    <span className="leading-relaxed">
                      {office.address[0]}<br />
                      {office.address[1]}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="pt-8 mt-8 border-t border-white/5 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-gray-600">
            &copy; {currentYear} {companyInfo.name}. All rights reserved.
          </p>
          <div className="flex flex-wrap justify-center gap-6">
            <Link to="/privacy" className="text-sm text-gray-600 hover:text-white transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-sm text-gray-600 hover:text-white transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

